(() => {
  if (window.location.pathname !== '/apps/wishlist') return;

  let previousCount = null;
  let syncing = false;

  function getCartIcon() {
    return document.querySelector('#cart-icon-bubble');
  }

  function getDisplayedCount() {
    const bubble = getCartIcon();
    if (!bubble) return null;
    const numeric = bubble.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if (numeric && /^\d+$/.test(numeric.textContent.trim())) return Number(numeric.textContent.trim());
    const hidden = bubble.querySelector('.cart-count-bubble .visually-hidden');
    const match = (hidden?.textContent || '').match(/(\d+)/);
    return match ? Number(match[1]) : null;
  }

  function updateCartIcon(count) {
    const bubble = getCartIcon();
    if (!bubble) return;
    let countBubble = bubble.querySelector('.cart-count-bubble');
    if (count <= 0) {
      countBubble?.remove();
      bubble.setAttribute('aria-label', 'Carrito vacío');
      return;
    }
    if (!countBubble) {
      countBubble = document.createElement('div');
      countBubble.className = 'cart-count-bubble';
      bubble.appendChild(countBubble);
    }
    let numeric = countBubble.querySelector('span[aria-hidden="true"]');
    if (!numeric) {
      numeric = document.createElement('span');
      numeric.setAttribute('aria-hidden', 'true');
      countBubble.prepend(numeric);
    }
    numeric.textContent = String(count);
    let hidden = countBubble.querySelector('.visually-hidden');
    if (!hidden) {
      hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      countBubble.appendChild(hidden);
    }
    hidden.textContent = count === 1 ? '1 artículo' : count + ' artículos';
    bubble.setAttribute('aria-label', count === 1 ? 'Carrito 1 artículo' : 'Carrito ' + count + ' artículos');
  }

  async function renderDrawer(cart, openDrawer) {
    updateCartIcon(cart.item_count);
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    let response;
    try {
      response = await fetch(cartUrl + '?section_id=cart-drawer&_=' + Date.now(), {
        headers: { Accept: 'text/html' },
        cache: 'no-store'
      });
    } catch (error) {
      console.warn('[Wishlist Plus] No se pudo cargar el cajón del carrito', error);
      return;
    }
    if (!response.ok) return;

    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const sourceDrawer = html.querySelector('cart-drawer');
    const currentDrawer = document.querySelector('cart-drawer');
    if (!sourceDrawer || !currentDrawer) return;

    currentDrawer.innerHTML = sourceDrawer.innerHTML;
    currentDrawer.classList.toggle('is-empty', cart.item_count === 0);
    const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', () => currentDrawer.close());
    updateCartIcon(cart.item_count);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'wishlist-plus',
        cartData: cart
      });
    }
    document.dispatchEvent(new CustomEvent('wishlist:cart-updated', { detail: cart }));

    if (openDrawer && typeof currentDrawer.open === 'function') {
      currentDrawer.open(getCartIcon());
    }
  }

  async function syncCart() {
    if (syncing) return;
    syncing = true;
    try {
      const response = await fetch('/cart.js?_=' + Date.now(), {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      const displayed = getDisplayedCount();
      const changed = previousCount !== null && cart.item_count !== previousCount;
      const stale = displayed !== null && displayed !== cart.item_count;
      const firstSyncNeedsRender = previousCount === null && displayed !== cart.item_count;
      previousCount = cart.item_count;
      if (changed || stale || firstSyncNeedsRender) await renderDrawer(cart, changed);
    } catch (error) {
      console.warn('[Wishlist Plus] No se pudo sincronizar el carrito', error);
    } finally {
      syncing = false;
    }
  }

  function start() {
    syncCart();
    window.setInterval(syncCart, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();